module.exports = __webpack_public_path__ + "img/stop-10.14c0522e.jpg";